import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchError, d as watchWarning, e as getFormFieldAttributes, f as getHostAttributes } from './p-De5ZxJ78.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { d as defineCustomElement$7 } from './p-BbTg3Car.js';
import { d as defineCustomElement$6 } from './p-RWl7wfjL.js';
import { d as defineCustomElement$5 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$4 } from './p-Cq913ncI.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const radioGroupCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.inner{display:flex;flex:1}:host([orientation=horizontal]) .inner{flex-direction:row;gap:1.5rem}:host([orientation=vertical]) .inner{flex-direction:column;gap:.75rem}:host([orientation=vertical]) wui-radio-button{width:100%}:host([size=lg]) .inner{gap:.75rem}";

const WuiRadioGroup$1 = /*@__PURE__*/ proxyCustomElement(class WuiRadioGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        /**
         * Options available for selection in this group
         */
        this.options = [];
        /**
         * Orientation of the group
         */
        this.orientation = 'vertical';
        this.size = 'md';
        /**
         * If disabled
         */
        this.disabled = false;
        this.handleInput = (e) => {
            // Stop inner radio button event from bubbling up
            e.stopPropagation();
            const target = e.target;
            if (!target) {
                return;
            }
            this.value = target.value;
            this.dirty = true;
            this.checkValidity();
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    renderInner() {
        return (h("div", { class: "inner" }, h("input", { hidden: true, type: "text", value: this.value, required: !!this.required, disabled: this.disabled, ref: this.setInputRef, onInput: (e) => {
                e.stopPropagation();
            }, onChange: (e) => {
                e.stopPropagation();
            } }), this.options?.map((option, idx) => {
            // Support string as well as RadioOption object
            const label = toLabel(option);
            const value = toValue(option);
            const disabled = typeof option === 'object' ? option.disabled : this.disabled;
            const description = typeof option === 'object' && 'description' in option ? option.description : undefined;
            return (h("wui-radio-button", { ...(typeof option === 'object' ? option : {}), key: idx, description: this.size === 'md' ? undefined : description, formField: this.size === 'md' && description ? { description } : undefined, disabled: disabled || this.disabled, required: this.required, name: this.name ? `${this.name}[]` : undefined, onChange: (e) => {
                    // Prevent change event from bubbling up
                    e.stopPropagation();
                }, onInput: this.handleInput, checked: value === this.value, label: label, value: value }));
        })));
    }
    render() {
        return (h(Host, { key: 'e20eb78bcc01104a17de00988ee5999f7e314f5d', ...getHostAttributes(this) }, h("wui-form-field", { key: 'f96024cc0b82f6b76fdfb0963518c2c8115ae95f', ...getFormFieldAttributes(this) }, this.renderInner())));
    }
    get elm() { return this; }
    static get watchers() { return {
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return radioGroupCss; }
}, [257, "wui-radio-group", {
        "value": [1025],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "name": [1],
        "options": [16],
        "orientation": [513],
        "size": [513],
        "disabled": [4],
        "customValidation": [32],
        "showValidity": [32]
    }, undefined, {
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-radio-group", "wui-box", "wui-form-field", "wui-icon", "wui-radio-button", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-radio-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiRadioGroup$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-radio-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiRadioGroup = WuiRadioGroup$1;
const defineCustomElement = defineCustomElement$1;

export { WuiRadioGroup, defineCustomElement };
